import React from "react";
import { Box, Stack } from "@mui/material";
import SubscriptionsTable from "./sections/SubscriptionsTable";
import { useSelector } from "react-redux";
import TopSectionSkeleton from "./sections/TopSectionSkeleton";
import BodySectionSkeleton from "./sections/BodySectionSkeleton";
import TopSection from "./sections/TopSection";
import { COMPANY_SERVICES } from "constants/subscriptions";
import {
    getSubscriptionStatusFromRow,
    SUBSCRIPTION_STATUSES,
} from "utils/subscriptionStatus";

const creditsFinder = (companyServices, serviceId) => {
    return (
        companyServices?.find((item) => item.service.id === serviceId)
            ?.credits ?? 0
    );
};

export default function SubscriptionsAndCredits() {
    const company = useSelector((state) => state.companySlice?.currentCompany);
    const companyServices = company?.companyServices;

    const actCredits = creditsFinder(
        companyServices,
        COMPANY_SERVICES.ACCESS_TO_TALENT.id,
    );

    const jobBoardCredits = creditsFinder(
        companyServices,
        COMPANY_SERVICES.JOB_BOARD.id,
    );

    const subscriptionHistory = company?.subscriptions;
    const defaultAccessToTalentCredits = actCredits;
    const defaultJobBoardCredits = jobBoardCredits;

    const remainingDays = company?.activeSubscription?.remainingDays;
    const upcomingPayment = company?.activeSubscription?.upcomingPayment;
    const successfulLastPayment =
        company?.activeSubscription?.successfulLastPayment;
    const isTrial =
        getSubscriptionStatusFromRow(company?.activeSubscription) ===
        SUBSCRIPTION_STATUSES.TRIAL;

    return (
        <Box
            component="article"
            aria-labelledby="access-to-talent-section-title"
        >
            <Stack gap={4}>
                {company ? (
                    <>
                        <TopSection
                            actCredits={defaultAccessToTalentCredits}
                            jobBoardCredits={defaultJobBoardCredits}
                            companyId={company.id}
                            remainingDays={remainingDays}
                            upcomingPayment={upcomingPayment}
                            successfulLastPayment={successfulLastPayment}
                            isTrial={isTrial}
                        />
                        <SubscriptionsTable
                            rows={subscriptionHistory}
                            talentRequests={defaultAccessToTalentCredits}
                            jobSlots={defaultJobBoardCredits}
                        />
                    </>
                ) : (
                    <Stack gap={4}>
                        <TopSectionSkeleton />
                        <BodySectionSkeleton />
                    </Stack>
                )}
            </Stack>
        </Box>
    );
}
